export const PROJECT_DASHBOARD = {
  // MSProjectDashboard elements
  MORE_MENU_BUTTON: 'project-dashboard-more-menu-button',
  LOAD_LIVE_DATA_MENU_ITEM: 'project-dashboard-load-live-data-menu-item',
  LOAD_DEMO_DATA_MENU_ITEM: 'project-dashboard-load-demo-data-menu-item',
  CONTENT_SCROLLER: 'project-dashboard-content-scroller',
  COMPARISON_WRAPPER: 'project-dashboard-comparison-wrapper',
  LOADING_COMPONENT: 'project-dashboard-loading-component',

  // WSProjectDashboard elements
  WS_DASHBOARD_WRAPPER: 'project-dashboard-ws-dashboard-wrapper',
  WS_DASHBOARD_HEADER: 'project-dashboard-ws-dashboard-header',
  WS_CONTENT_SCROLLER: 'project-dashboard-ws-content-scroller',
  WS_PPC_WRAPPER: 'project-dashboard-ws-ppc-wrapper',
  WS_VARIANCE_CODES_WRAPPER: 'project-dashboard-ws-variance-codes-wrapper',
  WS_IMPORTANT_DATES_WRAPPER: 'project-dashboard-ws-important-dates-wrapper',

  // Common dashboard elements
  DASHBOARD_HEADER_WRAPPER: 'project-dashboard-header-wrapper',
  DASHBOARD_HEADER: 'project-dashboard-header',
  PROJECT_DASHBOARD_WRAPPER: 'project-dashboard-wrapper',
  PROJECT_DASHBOARD_CONTENT: 'project-dashboard-content',
  BOX_LAYOUT: 'project-dashboard-box-layout',
  GRID_CONTAINER: 'project-dashboard-grid-container',
  STATS_WRAPPER: 'project-dashboard-stats-wrapper',
  COMPARISON_CHART_WRAPPER: 'project-dashboard-comparison-chart-wrapper',
  ACTIVITY_STATUS_CHART: 'project-dashboard-activity-status-chart',
  PROGRESS_STATUS_CHART: 'project-dashboard-progress-status-chart',
  GRID_ROW: 'project-dashboard-grid-row',
  METRICS_WRAPPER: 'project-dashboard-metrics-wrapper',
  QUALITY_SCORE_WRAPPER: 'project-dashboard-quality-score-wrapper',
  NEGATIVE_FLOAT_WRAPPER: 'project-dashboard-negative-float-wrapper',
  CRITICAL_ACTIVITIES_WRAPPER: 'project-dashboard-critical-activities-wrapper',
  PROGRESS_CURVE_WRAPPER: 'project-dashboard-progress-curve-wrapper',
  PROGRESS_CURVE_WRAPPER_PPC_DASHBOARD: 'progress-curve-wrapper-ppc-dashboard',
  PROGRESS_CURVE_WRAPPER_VC_DASHBOARD: 'progress-curve-wrapper-vc-dashboard',
  IMPORTANT_DATES_WRAPPER: 'project-dashboard-important-dates-wrapper'
} as const;
